import {
    GOOGLE_METADATA_BY_KEY,
    POPULARITY_METADATA_BY_KEY,
    SpateMetricMetadata,
    TIKTOK_METADATA_BY_KEY,
} from 'utils/metrics';

function createMetric(metric, { healthStatKey, key } = {}) {
    const { healthStatKey: _healthStatKey, ...restConfig } = metric.config;
    if (healthStatKey) {
        restConfig.healthStatKey = healthStatKey;
        restConfig.activeHealthStatLabel = true;
    }
    if (key) {
        restConfig.key = key;
    }
    return new SpateMetricMetadata(restConfig);
}

export const googleMetrics = [
    [createMetric(GOOGLE_METADATA_BY_KEY.volume), true],
    [
        createMetric(GOOGLE_METADATA_BY_KEY.YoY, { healthStatKey: 'growth' }),
        true,
    ],
    [
        createMetric(GOOGLE_METADATA_BY_KEY.absoluteGrowth, {
            key: 'increase_YoY',
        }),
        false,
    ],
    [createMetric(GOOGLE_METADATA_BY_KEY.QoQ), true],
    [
        createMetric(GOOGLE_METADATA_BY_KEY.QoQ_increase, {
            key: 'increase_QoQ',
        }),
        false,
    ],
    [createMetric(GOOGLE_METADATA_BY_KEY.MoM), false],
    [
        createMetric(GOOGLE_METADATA_BY_KEY.MoM_increase, {
            key: 'increase_MoM',
        }),
        false,
    ],
];

export const tiktokMetrics = [
    [
        createMetric(TIKTOK_METADATA_BY_KEY.non_cum_avg_weekly_views, {
            key: 'views',
        }),
        false,
    ],
    [
        createMetric(TIKTOK_METADATA_BY_KEY.non_cum_YoY_rolling, {
            key: 'YoY',
            healthStatKey: 'growth',
        }),
        true,
    ],
    [
        createMetric(TIKTOK_METADATA_BY_KEY.non_cum_increase_YoY_rolling, {
            key: 'increase_YoY',
        }),
        false,
    ],
    [
        createMetric(TIKTOK_METADATA_BY_KEY.non_cum_QoQ_rolling, {
            key: 'QoQ',
        }),
        true,
    ],
    [
        createMetric(TIKTOK_METADATA_BY_KEY.non_cum_increase_QoQ_rolling, {
            key: 'increase_QoQ',
        }),
        false,
    ],
    [
        createMetric(TIKTOK_METADATA_BY_KEY.non_cum_MoM_rolling, {
            key: 'MoM',
        }),
        false,
    ],
    [
        createMetric(TIKTOK_METADATA_BY_KEY.non_cum_increase_MoM_rolling, {
            key: 'increase_MoM',
        }),
        false,
    ],
    [createMetric(TIKTOK_METADATA_BY_KEY.views, { key: 'total_views' }), false],
];

export const popIndexMetrics = [
    [
        createMetric(POPULARITY_METADATA_BY_KEY.popularity_index_avg_12_month),
        true,
    ],
    [
        createMetric(POPULARITY_METADATA_BY_KEY.YoY, {
            healthStatKey: 'growth',
        }),
        true,
    ],
    [createMetric(POPULARITY_METADATA_BY_KEY.increase_YoY), false],
    [createMetric(POPULARITY_METADATA_BY_KEY.QoQ), true],
    [createMetric(POPULARITY_METADATA_BY_KEY.increase_QoQ), false],
    [createMetric(POPULARITY_METADATA_BY_KEY.MoM), false],
    [createMetric(POPULARITY_METADATA_BY_KEY.increase_MoM), false],
];
